var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2522_18070)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10.2857,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.7143,
    cy: 35.144,
    r: 7.71429,
    fill: "url(#paint0_linear_2522_18070)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.7143,
    cy: 19.714,
    r: 14.5714,
    fill: "url(#paint1_linear_2522_18070)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 31.7143,
    cy: 16.2854,
    r: 11.1429,
    fill: "url(#paint2_linear_2522_18070)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5714,
    cy: 30.856,
    r: 10.2857,
    fill: "url(#paint3_linear_2522_18070)",
    fillOpacity: 0.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.257143,
    y: 0.257143,
    width: 47.4857,
    height: 47.4857,
    rx: 10.0286,
    stroke: "#E4E4E4",
    strokeWidth: 0.514286
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2522_18070",
    x1: 28.2857,
    y1: 27.4297,
    x2: 12,
    y2: 42.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C200E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2522_18070",
    x1: 17.1428,
    y1: 2.57115,
    x2: 22.2857,
    y2: 36.8569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BE9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2522_18070",
    x1: 20.5714,
    y1: 5.14258,
    x2: 20.5714,
    y2: 27.4283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2522_18070",
    x1: 32.5714,
    y1: 18.856,
    x2: 32.5714,
    y2: 43.7132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF007E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2522_18070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10.2857,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.a8dbe3776e9b868f50db6f7d8659c6f5.svg";
export { ForwardRef as ReactComponent };